import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  IdDiarioObrasImagens: number;
  IdDiarioObras: number;
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
};

export const initialFiltersValues: State = {
  IdDiarioObrasImagens: 0,
  IdDiarioObras: 0,
};

export const useDiarioObrasImagensFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));